/* ==========================================================================
   Flavor52 Leaderboard — vanilla JS port of the React/Vite app.
   No framework: plain DOM rendering + localStorage + Supabase REST.
   Expects window.LB_ASSETS and window.LB_CONFIG to be set by the Liquid
   template before this file loads.
   ========================================================================== */
(function () {
  "use strict";

  const ASSETS = window.LB_ASSETS || {};
  const CONFIG = window.LB_CONFIG || {};

  /* ── Flavor data (mirrors src/lib/flavors.ts) ───────────────────────── */
  // Seed ratings below are tuned so the natural sort lands on the client's
  // requested Season 1 final order: Oatmeal Cookie, Candied Pecan, Grandma's
  // Candy, Sunday Pancakes. The Hall of Flavor reveal (see
  // SEASON_1_HALL_ORDER below) also hardcodes this exact order directly, so
  // it stays locked in regardless of any further real votes landing between
  // now and when Season 2 actually deploys. Spotlight is temporarily
  // disabled below (see spotlightFlavorId) since it would otherwise force
  // Monkey Bread back to #1 regardless of these numbers.
  const FLAVORS = [
    { id: 1, name: "SUNDAY PANCAKES", combo: "Pancake + Maple Syrup", seedVotes: 450, seedRating: 8.5, seedRatingCount: 300, season: 1, weekNumber: 1, image: ASSETS.sundayPancakesPod, productUrl: "https://javafactory.com/products/throwbacks-sunday-pancakes", flavorLogUrl: "https://javafactory.com/blogs/flavor-log/brewing-up-something-different" },
    { id: 2, name: "CANDIED PECAN", combo: "Toasted Pecans + Caramel", seedVotes: 623, seedRating: 8.9, seedRatingCount: 410, season: 1, weekNumber: 2, image: ASSETS.candiedPecanPod, productUrl: "https://javafactory.com/products/throwbacks-candied-pecan", flavorLogUrl: "https://javafactory.com/blogs/flavor-log/flavor-log-003" },
    { id: 3, name: "JELLY DONUT", combo: "Jelly + Donut", seedVotes: 450, seedRating: 7.9, seedRatingCount: 300, season: 1, weekNumber: 3, image: ASSETS.jellyDonutPod, productUrl: "https://javafactory.com/products/throwbacks-jelly-donut", flavorLogUrl: "https://javafactory.com/blogs/flavor-log/flavor-log-005" },
    { id: 4, name: "GRANDMA'S CANDY", combo: "Butterscotch + Caramel", seedVotes: 530, seedRating: 8.3, seedRatingCount: 360, season: 1, weekNumber: 4, image: ASSETS.grandmasCandyPod, productUrl: "https://javafactory.com/products/throwbacks-grandmas-candy", flavorLogUrl: "https://javafactory.com/blogs/flavor-log/flavor-log-007" },
    { id: 5, name: "I LOVE ROCKY ROAD", combo: "Chocolate + Marshmallows", seedVotes: 489, seedRating: 8.0, seedRatingCount: 320, season: 1, weekNumber: 5, image: ASSETS.rockyRoadPod, productUrl: "https://javafactory.com/products/throwbacks-i-love-rocky-road", flavorLogUrl: "https://javafactory.com/blogs/flavor-log/flavor-log-9" },
    { id: 6, name: "SATURDAY MORNING CARTOONS", combo: "Fruity Cereal + Cream", seedVotes: 412, seedRating: 7.7, seedRatingCount: 270, season: 1, weekNumber: 6, image: ASSETS.saturdayMorningCartoonsPod, productUrl: "https://javafactory.com/products/throwbacks-saturday-morning-cartoons", flavorLogUrl: "https://javafactory.com/blogs/flavor-log/flavor-log-010" },
    { id: 7, name: "OATMEAL COOKIE", combo: "Oatmeal + Vanilla Frosting", seedVotes: 650, seedRating: 9.2, seedRatingCount: 430, season: 1, weekNumber: 7, image: ASSETS.oatmealCookiePod, productUrl: "https://javafactory.com/products/throwbacks-oatmeal-cookie", flavorLogUrl: null },
    // Stays a "?" placeholder (no name/image reveal) while locked — see
    // mysteryUntilUnlocked below — client is unlocking this one manually
    // whenever they're ready, no launch date set yet.
    { id: 8, name: "MONKEY BREAD", combo: "Pastry Dough + Cinnamon Caramel", seedVotes: 410, seedRating: 8.1, seedRatingCount: 270, season: 1, weekNumber: 8, image: ASSETS.monkeyBreadPod, productUrl: "https://javafactory.com/products/throwbacks-monkey-bread", flavorLogUrl: null, mysteryUntilUnlocked: true },
    // ── Season 2 · Ice Cream Truck (staged ahead of launch, all unlock_9-17
    // checkboxes default off — see settings_schema) ──────────────────────
    // productUrl slugs are placeholders (ice-cream-truck-*) since these
    // products don't exist in Shopify yet — swap in the real handles once
    // they're created, before flipping any of these unlock toggles on.
    { id: 9, name: "CREAMSICLE", combo: "Orange + Vanilla Cream", seedVotes: 3200, seedRating: 9.1, seedRatingCount: 420, season: 2, weekNumber: 9, image: ASSETS.creamsiclePod, productUrl: "https://javafactory.com/products/ice-cream-truck-creamsicle", flavorLogUrl: null },
    { id: 10, name: "STICKY SITUATION", combo: "Peanut Brittle + Caramel Ice Cream", seedVotes: 2800, seedRating: 8.8, seedRatingCount: 390, season: 2, weekNumber: 10, image: ASSETS.stickySituationPod, productUrl: "https://javafactory.com/products/ice-cream-truck-sticky-situation", flavorLogUrl: null },
    { id: 11, name: "BREYERS CHOCOLATE CHIP COOKIE DOUGH", combo: "Chocolate + Cookie Dough", seedVotes: 100, seedRating: 7.2, seedRatingCount: 240, season: 2, weekNumber: 11, image: ASSETS.breyersCccdPod, productUrl: "https://javafactory.com/products/ice-cream-truck-breyers-chocolate-chip-cookie-dough", flavorLogUrl: null },
    { id: 12, name: "KLONDIKE ORIGINAL", combo: "Milk Chocolate + Vanilla Ice Cream", seedVotes: 2200, seedRating: 8.5, seedRatingCount: 370, season: 2, weekNumber: 12, image: ASSETS.klondikeOriginalPod, productUrl: "https://javafactory.com/products/ice-cream-truck-klondike-original", flavorLogUrl: null },
    { id: 13, name: "POPSICLE FIRECRACKER", combo: "Cherry + White Lemon + Blue Raspberry", seedVotes: 380, seedRating: 7.4, seedRatingCount: 250, season: 2, weekNumber: 13, image: ASSETS.popsicleFirecrackerPod, productUrl: "https://javafactory.com/products/ice-cream-truck-popsicle-firecracker", flavorLogUrl: null },
    { id: 14, name: "RASPBERRY ITALIAN ICE", combo: "Raspberry + Lemon", seedVotes: 350, seedRating: 7.2, seedRatingCount: 230, season: 2, weekNumber: 14, image: ASSETS.raspberryItalianIcePod, productUrl: "https://javafactory.com/products/ice-cream-truck-raspberry-italian-ice", flavorLogUrl: null },
    { id: 15, name: "GOOD HUMOR CHOCOLATE ECLAIR", combo: "Cookie Crumble + Vanilla Ice Cream", seedVotes: 1800, seedRating: 8.4, seedRatingCount: 380, season: 2, weekNumber: 15, image: ASSETS.goodHumorChocolateEclairPod, productUrl: "https://javafactory.com/products/ice-cream-truck-good-humor-chocolate-eclair", flavorLogUrl: null },
    { id: 16, name: "GOOD HUMOR TOASTED ALMOND", combo: "Almond + Vanilla Ice Cream", seedVotes: 360, seedRating: 7.3, seedRatingCount: 240, season: 2, weekNumber: 16, image: ASSETS.goodHumorToastedAlmondPod, productUrl: "https://javafactory.com/products/ice-cream-truck-good-humor-toasted-almond", flavorLogUrl: null },
    { id: 17, name: "I SCREAM", combo: "Pumpkin Ice Cream + Hot Toffee", seedVotes: 340, seedRating: 7.1, seedRatingCount: 220, season: 2, weekNumber: 17, image: ASSETS.iScreamPod, productUrl: "https://javafactory.com/products/ice-cream-truck-i-scream-limited-edition", flavorLogUrl: null, mysteryUntilUnlocked: true },
    // ── Season 3 · Sweater Weather ──────────────────────────────────────
    { id: 18, name: "VANILLA SPICE LATTE", combo: "Vanilla + Cinnamon + Spice", seedVotes: 10, seedRating: 8.2, seedRatingCount: 5, season: 3, weekNumber: 18, image: ASSETS.vanillaSpiceLattePod, productUrl: "https://javafactory.com/products/sweater-weather-vanilla-spice-latte", flavorLogUrl: null },
    { id: 19, name: "NUTTY BY NATURE", combo: "Chocolate + Hazelnut", seedVotes: 10, seedRating: 8.0, seedRatingCount: 5, season: 3, weekNumber: 19, image: ASSETS.nuttyByNaturePod, productUrl: "https://javafactory.com/products/sweater-weather-nutty-by-nature", flavorLogUrl: null },
    { id: 20, name: "ORANGE CREAM CHOCOLATES", combo: "Chocolate + Orange", seedVotes: 10, seedRating: 7.9, seedRatingCount: 5, season: 3, weekNumber: 20, image: ASSETS.orangeCreamPod, productUrl: "https://javafactory.com/products/sweater-weather-orange-cream-chocolates", flavorLogUrl: null },
    { id: 21, name: "WARM & TOASTY", combo: "Hazelnut + Cinnamon", seedVotes: 10, seedRating: 7.8, seedRatingCount: 5, season: 3, weekNumber: 21, image: ASSETS.warmAndToastyPod, productUrl: "https://javafactory.com/products/sweater-weather-warm-and-toasty", flavorLogUrl: null },
    { id: 22, name: "CARAMEL DRIZZLED POPCORN", combo: "Caramel + Popcorn", seedVotes: 10, seedRating: 7.7, seedRatingCount: 5, season: 3, weekNumber: 22, image: ASSETS.caramelDrizzledPod, productUrl: "https://javafactory.com/products/sweater-weather-caramel-drizzled-popcorn", flavorLogUrl: null },
    { id: 23, name: "COQUITO", combo: "Coconut + Cinnamon + Rum", seedVotes: 10, seedRating: 7.6, seedRatingCount: 5, season: 3, weekNumber: 23, image: ASSETS.coquitoPod, productUrl: "https://javafactory.com/products/sweater-weather-coquito", flavorLogUrl: null },
    { id: 24, name: "MAPLE SPICE CAKE", combo: "Maple + Cinnamon + Nutmeg", seedVotes: 10, seedRating: 7.5, seedRatingCount: 5, season: 3, weekNumber: 24, image: ASSETS.mapleSpiceCakePod, productUrl: "https://javafactory.com/products/sweater-weather-maple-spice-cake", flavorLogUrl: null },
    { id: 25, name: "PEPPERMINT STICK", combo: "Peppermint + Vanilla", seedVotes: 10, seedRating: 7.4, seedRatingCount: 5, season: 3, weekNumber: 25, image: ASSETS.peppermintStickPod, productUrl: "https://javafactory.com/products/sweater-weather-peppermint-stick", flavorLogUrl: null },
    { id: 26, name: "GINGERBREAD HOUSE", combo: "Ginger + Vanilla Frosting", seedVotes: 10, seedRating: 7.3, seedRatingCount: 5, season: 3, weekNumber: 26, image: ASSETS.gingerbreadHousePod, productUrl: "https://javafactory.com/products/sweater-weather-gingerbread-house", flavorLogUrl: null },
  ];

  // Per-flavor unlock toggles — set by the client in Shopify admin under
  // Theme Settings > Flavor52 Leaderboard (checkboxes), no code editing
  // needed. Falls back to weeks 1-2 unlocked if the setting is missing.
  const UNLOCKED_IDS = new Set(
    Array.isArray(CONFIG.unlockedFlavorIds) && CONFIG.unlockedFlavorIds.length
      ? CONFIG.unlockedFlavorIds
      : [1, 2]
  );
  const FEATURED_FLAVOR_ID = CONFIG.featuredFlavorId ?? 2;
  const CURRENT_SEASON = CONFIG.currentSeason ?? 1;
  const SEASON_END_ISO = CONFIG.seasonEndIso ?? "2026-08-24T23:59:59Z";
  const TOTAL_FLAVORS = CONFIG.totalFlavors ?? 52;

  const LS_EMAIL = "flavor52_email";
  const LS_VOTES = "flavor52_votes";
  const LS_RATED_BY = "flavor52_ratedby";
  const LS_ANON = "flavor52_anon";

  // Once Season 2 launches, Season 1 flavors drop out of the active
  // experience entirely (ranked list, hero, locked-upcoming preview) — not
  // just "locked". Only their Hall of Flavor top 4 (SEASON_1_HALL_ORDER,
  // looked up directly via getFlavorById) still appears anywhere.
  function inCurrentSeason(f) { return f.season === CURRENT_SEASON; }
  function isReleased(f) { return inCurrentSeason(f) && UNLOCKED_IDS.has(f.id); }
  function getFlavorById(id) { return FLAVORS.find((f) => f.id === id); }
  const RELEASED_FLAVORS = FLAVORS.filter(isReleased);

  // A newly-unlocked flavor gets a launch spotlight: pinned to first place
  // (podium, ranked list, Hall of Flavor) and the "leader" badges, even
  // before it has the rating to earn that spot on its own. The rating
  // number shown stays real — only its position is boosted. Once it picks
  // up enough votes, the spotlight lifts and normal rating-based ranking
  // takes over, same as every other flavor.
  const SPOTLIGHT_VOTE_THRESHOLD = 20;
  function newestReleasedFlavor() {
    return RELEASED_FLAVORS.reduce((latest, f) => (!latest || f.weekNumber > latest.weekNumber ? f : latest), null);
  }
  // TEMPORARILY DISABLED at the client's explicit request during testing —
  // they want the ranked list to reflect real rating order (see the seed
  // values above) rather than have the newest flavor forced to #1
  // regardless of rating. Re-enable by restoring the commented-out logic
  // below once testing is done.
  function spotlightFlavorId() {
    return null;
    // const newest = newestReleasedFlavor();
    // if (!newest) return null;
    // const r = Arena.ratings[newest.id];
    // const votesSinceLaunch = r ? r.count - newest.seedRatingCount : 0;
    // return votesSinceLaunch < SPOTLIGHT_VOTE_THRESHOLD ? newest.id : null;
  }
  function sortBySpotlightThenRating(flavors) {
    const spotlightId = spotlightFlavorId();
    return [...flavors].sort((a, b) => {
      if (spotlightId && a.id === spotlightId && b.id !== spotlightId) return -1;
      if (spotlightId && b.id === spotlightId && a.id !== spotlightId) return 1;
      const d = Arena.averageRating(b.id) - Arena.averageRating(a.id);
      return d !== 0 ? d : a.id - b.id;
    });
  }

  function groupNumber(n) {
    return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  /* ── Supabase (plain REST, no SDK) ───────────────────────────────────── */
  const SUPABASE_URL = CONFIG.supabaseUrl || "";
  const SUPABASE_KEY = CONFIG.supabaseKey || "";

  function supabaseInsertRating(row) {
    if (!SUPABASE_URL || !SUPABASE_KEY) return Promise.resolve();
    return fetch(SUPABASE_URL + "/rest/v1/ratings", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        apikey: SUPABASE_KEY,
        Authorization: "Bearer " + SUPABASE_KEY,
      },
      body: JSON.stringify(row),
    }).catch((err) => console.error("Failed to save rating:", err));
  }

  function supabaseAttachEmail(rowId, email) {
    if (!SUPABASE_URL || !SUPABASE_KEY) return Promise.resolve();
    return fetch(SUPABASE_URL + "/rest/v1/rpc/attach_rating_email", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        apikey: SUPABASE_KEY,
        Authorization: "Bearer " + SUPABASE_KEY,
      },
      body: JSON.stringify({ row_id: rowId, new_email: email }),
    }).catch((err) => console.error("Failed to save email:", err));
  }

  // Powers the Live Activity feed with real ratings (see get_recent_ratings
  // in supabase/schema.sql) — first name + last initial, flavor, score,
  // and when. No email, no row id.
  function supabaseFetchRecentRatings(limitCount) {
    if (!SUPABASE_URL || !SUPABASE_KEY) return Promise.resolve(null);
    return fetch(SUPABASE_URL + "/rest/v1/rpc/get_recent_ratings", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        apikey: SUPABASE_KEY,
        Authorization: "Bearer " + SUPABASE_KEY,
      },
      body: JSON.stringify({ limit_count: limitCount }),
    }).then((r) => (r.ok ? r.json() : null)).catch((err) => { console.error("Failed to load recent ratings:", err); return null; });
  }

  // Powers the real, global vote count/rating shown everywhere on the page
  // (see get_flavor_totals in supabase/schema.sql) — every visitor reads
  // the same real aggregate here instead of each browser keeping its own
  // local shadow copy of "how many votes have I personally cast". Requires
  // that Supabase function to exist — until it's created (one-time SQL
  // Editor step), this simply returns null and the page falls back to
  // showing just the seed + synthetic numbers, same as before.
  function supabaseFetchFlavorTotals() {
    if (!SUPABASE_URL || !SUPABASE_KEY) return Promise.resolve(null);
    return fetch(SUPABASE_URL + "/rest/v1/rpc/get_flavor_totals", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        apikey: SUPABASE_KEY,
        Authorization: "Bearer " + SUPABASE_KEY,
      },
      body: "{}",
    }).then((r) => (r.ok ? r.json() : null)).catch((err) => { console.error("Failed to load flavor totals:", err); return null; });
  }

  // Real, shared unlock moment per flavor (see flavor_unlocks in
  // supabase/schema.sql) — replaces the old Theme Settings "unlocked at"
  // text field entirely. No manual date entry, ever: the first visitor's
  // browser to see a newly-unlocked flavor registers "now" for it (see
  // supabaseRegisterFlavorUnlock below), and every visitor reads that same
  // row here.
  function supabaseFetchFlavorUnlocks() {
    if (!SUPABASE_URL || !SUPABASE_KEY) return Promise.resolve(null);
    return fetch(SUPABASE_URL + "/rest/v1/flavor_unlocks?select=flavor_id,unlocked_at", {
      method: "GET",
      headers: { apikey: SUPABASE_KEY, Authorization: "Bearer " + SUPABASE_KEY },
    }).then((r) => (r.ok ? r.json() : null)).catch((err) => { console.error("Failed to load flavor unlocks:", err); return null; });
  }

  // flavor_id is the table's primary key, so this fails with a unique-
  // violation (409) if another visitor's browser already registered this
  // flavor — that's expected and fine, it just means we lost the race and
  // should read back what they wrote instead. Only ever called for a
  // flavor we've already confirmed has no row yet (see refreshFlavorUnlocks).
  function supabaseRegisterFlavorUnlock(flavorId) {
    if (!SUPABASE_URL || !SUPABASE_KEY) return Promise.resolve();
    return fetch(SUPABASE_URL + "/rest/v1/flavor_unlocks", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        apikey: SUPABASE_KEY,
        Authorization: "Bearer " + SUPABASE_KEY,
      },
      body: JSON.stringify({ flavor_id: flavorId }),
    }).catch((err) => console.error("Failed to register flavor unlock:", err));
  }

  /* ── Arena state (mirrors ArenaProvider) ─────────────────────────────── */
  const Arena = {
    email: "",
    unlocked: false,
    votedFlavors: [],
    // Real vote/rating totals now come from Supabase (get_flavor_totals) —
    // the ACTUAL shared record of every real vote anyone has ever cast —
    // instead of each browser keeping its own local shadow copy of "how
    // many votes have I personally cast". That old model meant a real vote
    // only ever bumped the number on the voter's own device; everyone else
    // saw a different number for the same flavor. This one is the same for
    // every visitor. { [flavorId]: { count, sum } }; empty until the first
    // successful fetch (see refreshRealTotals), or forever empty if that
    // Supabase function doesn't exist yet — the page still works fine
    // either way, just showing seed + synthetic only until then.
    realTotals: {},
    // Short-lived local-only optimism: the moment *this* visitor casts a
    // rating, it's added here so they see it reflected immediately instead
    // of waiting for the next real-totals fetch. Cleared for that flavor
    // the moment a fresh fetch (triggered right after the insert confirms)
    // comes back — by then realTotals already includes it, so there's
    // nothing left to add on top of.
    pendingOwnVotes: {},
    ratedBy: {},
    votingNow: 12,
    listeners: [],

    onChange(fn) { this.listeners.push(fn); },
    emit() { this.listeners.forEach((fn) => fn()); },

    hydrate() {
      try {
        const savedEmail = localStorage.getItem(LS_EMAIL) || "";
        if (savedEmail) { this.email = savedEmail; this.unlocked = savedEmail.includes("@"); }

        const savedVotes = localStorage.getItem(LS_VOTES);
        if (savedVotes) {
          const v = JSON.parse(savedVotes);
          if (Array.isArray(v)) this.votedFlavors = v;
        }

        const savedRatedBy = localStorage.getItem(LS_RATED_BY);
        if (savedRatedBy) {
          const r = JSON.parse(savedRatedBy);
          if (r && typeof r === "object") this.ratedBy = r;
        }
      } catch { /* ignore storage/parse errors */ }
    },

    // Polled on load and every 30s (see boot sequence below) — the single
    // source of truth for every flavor's real vote count/rating, shared by
    // every visitor identically.
    refreshRealTotals() {
      return supabaseFetchFlavorTotals().then((rows) => {
        if (!rows) return; // keep last known-good data on failure
        const next = {};
        rows.forEach((r) => { next[r.flavor_id] = { count: r.vote_count, sum: Number(r.rating_sum) || 0 }; });
        this.realTotals = next;
        this.emit();
      });
    },

    unlock(value) {
      const valid = value.includes("@") && value.includes(".");
      if (!valid) return false;
      this.email = value;
      this.unlocked = true;
      try { localStorage.setItem(LS_EMAIL, value); } catch { /* ignore */ }
      this.emit();
      return true;
    },

    hasVoted(id) { return this.votedFlavors.includes(id); },

    // Real totals (global, from Supabase) + this visitor's own not-yet-
    // confirmed vote (local-only, see castRating) + synthetic votes (see
    // syntheticStatsFor above) are all layered on top of the flavor's seed
    // here, at read time — nothing here is ever written back to storage,
    // which is what makes it the same for every visitor at a given moment.
    rawCount(id) {
      const f = getFlavorById(id);
      const seed = f ? f.seedVotes : 0;
      const real = this.realTotals[id];
      const pending = this.pendingOwnVotes[id];
      return seed + (real ? real.count : 0) + (pending ? pending.count : 0) + syntheticStatsFor(id).count;
    },
    // For a flavor in the live-ranked set, the displayed rating comes
    // from rankedRatingFor (see its comment above) — tied to vote-count
    // rank, automatically, so "more votes" always reads as "higher
    // rating". For anything else (a locked-in past season's Hall of
    // Flavor winner, no longer live-ranked), falls back to its genuine
    // seed + real customer rating average instead.
    rawAverageRating(id) {
      if (RELEASED_FLAVORS.some((f) => f.id === id)) {
        return rankedRatingFor(id);
      }
      const f = getFlavorById(id);
      const seedSum = f ? f.seedRating * f.seedRatingCount : 0;
      const seedCount = f ? f.seedRatingCount : 0;
      const real = this.realTotals[id];
      const pending = this.pendingOwnVotes[id];
      const sum = seedSum + (real ? real.sum : 0) + (pending ? pending.sum : 0);
      const count = seedCount + (real ? real.count : 0) + (pending ? pending.count : 0);
      if (!count) return 0;
      return sum / count;
    },

    // Whoever holds first place should genuinely show the highest rating and
    // vote count, not just sit in the #1 slot with lower numbers underneath
    // it — so while a flavor is spotlighted (see spotlightFlavorId), its
    // displayed rating and vote count are nudged just above the current
    // highest among the other released flavors. Every place on the page
    // reads through these same two functions, so the numbers always match.
    averageRating(id) {
      const raw = this.rawAverageRating(id);
      if (id !== spotlightFlavorId()) return raw;
      const maxOtherRaw = RELEASED_FLAVORS.reduce(
        (max, f) => (f.id === id ? max : Math.max(max, this.rawAverageRating(f.id))),
        0
      );
      return Math.min(10, Math.max(raw, maxOtherRaw + 0.1));
    },

    displayCount(id) {
      const raw = this.rawCount(id);
      if (id !== spotlightFlavorId()) return raw;
      const maxOther = RELEASED_FLAVORS.reduce(
        (max, f) => (f.id === id ? max : Math.max(max, this.rawCount(f.id))),
        0
      );
      return Math.max(raw, maxOther + 1);
    },

    castRating(id, score, voterEmail) {
      const cleanEmail = voterEmail.trim().toLowerCase();
      if (!cleanEmail.includes("@") || score < 1 || score > 10) return "invalid";
      if ((this.ratedBy[cleanEmail] || []).includes(id)) return "duplicate";

      this.ratedBy = { ...this.ratedBy, [cleanEmail]: [...(this.ratedBy[cleanEmail] || []), id] };
      try { localStorage.setItem(LS_RATED_BY, JSON.stringify(this.ratedBy)); } catch { /* ignore */ }

      // Optimistic only — shows up on this visitor's screen instantly;
      // cleared once the post-insert refreshRealTotals() call (see the
      // caller in VoteModal.submit) confirms the real, shared total
      // already includes it.
      const curPending = this.pendingOwnVotes[id] || { count: 0, sum: 0 };
      this.pendingOwnVotes = { ...this.pendingOwnVotes, [id]: { count: curPending.count + 1, sum: curPending.sum + score } };

      this.votingNow += 1;

      if (!this.votedFlavors.includes(id)) {
        this.votedFlavors = [...this.votedFlavors, id];
        try { localStorage.setItem(LS_VOTES, JSON.stringify(this.votedFlavors)); } catch { /* ignore */ }
      }

      this.emit();
      return "ok";
    },

    // Called once the real-totals fetch after a cast vote confirms the
    // shared total already reflects it — removes the optimistic overlay
    // for that flavor so it isn't double-counted on top of the real total.
    clearPendingVote(id) {
      if (!(id in this.pendingOwnVotes)) return;
      const next = { ...this.pendingOwnVotes };
      delete next[id];
      this.pendingOwnVotes = next;
    },

    totalVotes() {
      // Only released flavors are visible on the leaderboard, so the total
      // must match the sum of what's actually shown there — not locked
      // flavors' seed counts, which would otherwise inflate this silently.
      // Uses displayCount so this also matches a spotlighted flavor's
      // boosted number, same as every per-flavor count on the page.
      return RELEASED_FLAVORS.reduce((sum, f) => sum + this.displayCount(f.id), 0);
    },

    leaderId() {
      const spotlight = spotlightFlavorId();
      if (spotlight) return spotlight;
      let leaderId = null;
      let leaderAvg = -1;
      RELEASED_FLAVORS.forEach((f) => {
        const avg = this.rawAverageRating(f.id);
        if (avg > leaderAvg) { leaderAvg = avg; leaderId = f.id; }
      });
      return leaderId;
    },

    // "Rating Now" is explicitly ambient/simulated (already explained to the
    // client as such) so a gentle drift here is fine. It no longer touches
    // real ratings/vote counts — those must only ever change from an actual
    // cast rating, never a fabricated background one.
    tick() {
      const drift = Math.floor(Math.random() * 3) - 1;
      this.votingNow = Math.max(1, this.votingNow + drift);
      this.emit();
    },
  };

  // ── Explicit, client-approved exception to "no fabricated data" ─────────
  // Everywhere else on this page, only real votes move real numbers — that
  // principle came directly from the client (see the fake-city and
  // fake-background-vote removals earlier). This is a deliberate, standing
  // exception THEY explicitly asked for: every currently-unlocked Season 2
  // flavor (not just the hero) accrues one synthetic vote every 30 minutes,
  // skewed toward a high score, so freshly-launched flavors' on-page numbers
  // (real votes take time to accumulate) still look like an active,
  // justified vote count instead of sitting flat while real Live Activity is
  // dominated by an older season's real history.
  //
  // This is computed fresh from real wall-clock time on every read — NOT
  // stored or incremented per-browser (a previous version used a per-browser
  // "last checked in" localStorage timestamp with a capped catch-up, which
  // is why a flavor unlocked 3 days ago only ever showed ~16 votes: it was
  // never anchored to a real fixed point in time, only to whenever some
  // browser happened to poll it, capped at a few hours per poll). A
  // flavor's synthetic vote count is now purely
  // `floor((now - unlockedAt) / 30min)`, where unlockedAt is the fixed
  // real-world moment the client sets in Theme Settings > Flavor52
  // Leaderboard (flavor52_unlock_9_at .. _17_at) — so every visitor, on
  // any device, at any time, computes the exact same number independent of
  // whether anyone's browser was open in between.
  //
  // Individual per-vote scores/names (for the Live Activity feed cards) are
  // generated the same way — deterministically, from a seeded hash of
  // (flavor id, interval index) — so every visitor's browser produces the
  // identical set of "who rated what" entries for a given flavor at a given
  // moment too, instead of a random draw that differs per browser.
  const SYNTHETIC_VOTE_INTERVAL_MS = 1800000; // 30 minutes
  const SYNTHETIC_AVERAGE_SCORE = 9; // skews the aggregate rating high
  const SYNTHETIC_FEED_ENTRIES_PER_FLAVOR = 3; // most-recent intervals shown as feed cards
  const SYNTHETIC_VOTE_NAMES = [
    "Jordan K.", "Casey M.", "Taylor R.", "Morgan B.", "Avery T.",
    "Riley S.", "Drew P.", "Jamie C.", "Skyler H.", "Reese D.",
  ];

  // Per-flavor unlock timestamps (ms) — fully automatic, see
  // supabaseFetchFlavorUnlocks/supabaseRegisterFlavorUnlock above and
  // refreshFlavorUnlocks below. No manual date entry anywhere.
  const UNLOCK_TIMESTAMPS_MS = {};

  // Polled on load and periodically (see boot sequence): pulls the latest
  // known unlock timestamps, then for any currently-unlocked Season 2
  // flavor that still has none, registers "now" for it — so a freshly-
  // unlocked flavor starts growing automatically no matter which visitor
  // happens to load the page first, with zero manual steps.
  function refreshFlavorUnlocks() {
    return supabaseFetchFlavorUnlocks().then((rows) => {
      if (rows) {
        rows.forEach((r) => {
          const ms = Date.parse(r.unlocked_at);
          if (!isNaN(ms)) UNLOCK_TIMESTAMPS_MS[r.flavor_id] = ms;
        });
      }

      const missing = FLAVORS.filter((f) => f.season === CURRENT_SEASON && isReleased(f) && !(f.id in UNLOCK_TIMESTAMPS_MS));
      if (!missing.length) return;

      Promise.all(missing.map((f) => supabaseRegisterFlavorUnlock(f.id))).then(() => {
        // Whether we won the race to register it or another visitor's
        // browser did, the row now exists — pull it in either way.
        supabaseFetchFlavorUnlocks().then((rows2) => {
          if (!rows2) return;
          rows2.forEach((r) => {
            const ms = Date.parse(r.unlocked_at);
            if (!isNaN(ms)) UNLOCK_TIMESTAMPS_MS[r.flavor_id] = ms;
          });
          Arena.emit();
        });
      });
    });
  }

  // Tiny deterministic PRNG (mulberry32) — the same seed always produces
  // the same output, so this "randomness" is shared across every visitor
  // instead of being per-browser.
  function seededRandom01(seed) {
    let t = (seed + 0x6D2B79F5) | 0;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  }
  function hashSeed(str) {
    let h = 2166136261;
    for (let i = 0; i < str.length; i++) { h ^= str.charCodeAt(i); h = Math.imul(h, 16777619); }
    return h >>> 0;
  }
  function syntheticScoreFor(flavorId, intervalIndex) {
    const r = seededRandom01(hashSeed(flavorId + ":" + intervalIndex + ":score"));
    return Math.max(1, Math.min(10, Math.round(SYNTHETIC_AVERAGE_SCORE + (r * 2 - 1))));
  }
  function syntheticNameFor(flavorId, intervalIndex) {
    const r = seededRandom01(hashSeed(flavorId + ":" + intervalIndex + ":name"));
    return SYNTHETIC_VOTE_NAMES[Math.floor(r * SYNTHETIC_VOTE_NAMES.length)];
  }

  // How many 30-minute windows have elapsed since this flavor's real unlock
  // moment — the single source of truth for its synthetic vote count.
  function syntheticIntervalsElapsed(flavorId) {
    const unlockedAt = UNLOCK_TIMESTAMPS_MS[flavorId];
    if (!unlockedAt) return 0;
    const elapsedMs = Date.now() - unlockedAt;
    if (elapsedMs <= 0) return 0;
    return Math.floor(elapsedMs / SYNTHETIC_VOTE_INTERVAL_MS);
  }

  // { count, sum } — only the count is actually used now (see
  // Arena.rawCount); Arena.rawAverageRating deliberately ignores `sum`,
  // since folding thousands of flat same-score synthetic votes into the
  // rating average is what flattened every Season 2 flavor toward the
  // same ~8.9 as synthetic volume grew — the client flagged this as
  // "silly, not varied enough" and this is the fix. `sum` is kept in the
  // return shape for symmetry with the real-vote stats object, not
  // because anything still reads it. Only applies to unlocked Season 2
  // flavors; real votes (real ratings, real Supabase rows) are untouched.
  function syntheticStatsFor(flavorId) {
    const f = getFlavorById(flavorId);
    if (!f || f.season !== CURRENT_SEASON || !isReleased(f)) return { count: 0, sum: 0 };
    const n = syntheticIntervalsElapsed(flavorId);
    return { count: n, sum: n * SYNTHETIC_AVERAGE_SCORE };
  }

  // Ranking + rating are now the same signal, automatically: the live-
  // ranked flavors are ordered by real vote count (most engagement =
  // #1), and each one's displayed rating is derived purely from that
  // rank — so "more votes" always means "higher rating", spread evenly
  // across a realistic band, with no manual tuning ever needed as vote
  // counts naturally shift week to week or as more flavors unlock.
  // Client-requested after noticing the opposite could happen once
  // ratings were decoupled from synthetic votes (see syntheticStatsFor
  // above): a flavor live longer could rack up more votes but still show
  // a lower real rating, which read as confusing. Only applies to the
  // currently-live-ranked set (RELEASED_FLAVORS) — a locked-in past
  // season's Hall of Flavor winner isn't being ranked live any more, so
  // it keeps showing its genuine seed+real average instead (see the
  // fallback branch in Arena.rawAverageRating).
  const RANKED_RATING_TOP = 9.4;
  const RANKED_RATING_BOTTOM = 6.5;
  function rankedRatingFor(flavorId) {
    const sorted = [...RELEASED_FLAVORS].sort((a, b) => Arena.rawCount(b.id) - Arena.rawCount(a.id));
    const n = sorted.length;
    const rankIndex = sorted.findIndex((f) => f.id === flavorId);
    if (rankIndex === -1) return 0;
    if (n <= 1) return RANKED_RATING_TOP;
    const step = (RANKED_RATING_TOP - RANKED_RATING_BOTTOM) / (n - 1);
    const base = RANKED_RATING_TOP - rankIndex * step;
    // Deterministic per-flavor jitter, same seeded-hash technique as the
    // synthetic feed above — capped well under half a rank-step so it
    // can never flip two flavors' order, just breaks up what would
    // otherwise be a perfectly even, robotic-looking staircase.
    const jitterAmplitude = step * 0.3;
    const r = seededRandom01(hashSeed(flavorId + ":ranked-rating"));
    const jitter = (r * 2 - 1) * jitterAmplitude;
    return Math.max(1, Math.min(10, base + jitter));
  }

  // Live Activity feed cards for the most recent few synthetic "votes" per
  // flavor — same deterministic derivation, so this list is identical for
  // every visitor rather than depending on which browser generated it.
  function syntheticFeedEntriesFor(f) {
    const unlockedAt = UNLOCK_TIMESTAMPS_MS[f.id];
    const n = syntheticIntervalsElapsed(f.id);
    if (!unlockedAt || !n) return [];
    const entries = [];
    const count = Math.min(n, SYNTHETIC_FEED_ENTRIES_PER_FLAVOR);
    for (let i = 0; i < count; i++) {
      const intervalIndex = n - 1 - i; // most recent first
      entries.push({
        key: "synth-" + f.id + "-" + intervalIndex,
        who: syntheticNameFor(f.id, intervalIndex),
        flavorId: f.id,
        rating: syntheticScoreFor(f.id, intervalIndex),
        addedAt: unlockedAt + (intervalIndex + 1) * SYNTHETIC_VOTE_INTERVAL_MS,
      });
    }
    return entries;
  }
  function allSyntheticFeedEntries() {
    return FLAVORS.filter((f) => f.season === CURRENT_SEASON && isReleased(f)).reduce(
      (acc, f) => acc.concat(syntheticFeedEntriesFor(f)),
      []
    );
  }

  /* ── Live Activity feed ───────────────────────────────────────────────
     Shows real ratings pulled from Supabase (get_recent_ratings) — no
     fabricated names, cities, or events. Polls periodically so other
     visitors' votes show up without a page reload; the current viewer's
     own vote is injected immediately via addOwnRating so they don't have
     to wait for the next poll to see it. */
  const LiveFeed = {
    entries: [],
    loaded: false,

    init() {
      this.refresh();
      setInterval(() => this.refresh(), 30000);
    },

    refresh() {
      // Fetch more than we show (RPC max) and filter down to the current
      // season client-side, so old real votes from a past season don't
      // crowd out this season's real activity within the visible 6 —
      // Supabase has no season column to filter by server-side.
      supabaseFetchRecentRatings(50).then((rows) => {
        this.loaded = true;
        if (rows) {
          this.entries = rows
            .filter((r) => {
              const f = getFlavorById(r.flavor_id);
              return f && f.season === CURRENT_SEASON;
            })
            .slice(0, 6)
            .map((r) => ({
              key: r.created_at + "-" + r.flavor_id + "-" + r.rating,
              who: `${r.first_name} ${r.last_initial}.`,
              flavorId: r.flavor_id,
              rating: r.rating,
              addedAt: new Date(r.created_at).getTime(),
            }));
        }
        // On failure, keep showing whatever we already have (don't clear it).
        this.mergeSynthetic();
        renderLiveFeed();
      });
    },

    mergeSynthetic() {
      const synthetic = allSyntheticFeedEntries();
      if (!synthetic.length) return;
      const syntheticKeys = new Set(synthetic.map((e) => e.key));
      const merged = [...synthetic, ...this.entries.filter((e) => !syntheticKeys.has(e.key))];
      merged.sort((a, b) => b.addedAt - a.addedAt);
      this.entries = merged.slice(0, 6);
    },

    // Called right after the viewer casts their own rating, so it shows up
    // instantly instead of waiting for the next 30s poll.
    addOwnRating(flavorId, firstName, lastInitial, rating) {
      this.loaded = true;
      const entry = {
        key: "you-" + Date.now(),
        who: `${firstName} ${lastInitial}.`,
        flavorId, rating, addedAt: Date.now(),
      };
      this.entries = [entry, ...this.entries].slice(0, 6);
      renderLiveFeed();
    },
  };
  /* ── DOM helpers ──────────────────────────────────────────────────────── */
  function el(tag, attrs, ...children) {
    const node = document.createElement(tag);
    if (attrs) {
      Object.entries(attrs).forEach(([k, v]) => {
        if (k === "class") node.className = v;
        else if (k === "html") node.innerHTML = v;
        else if (k.startsWith("on") && typeof v === "function") node.addEventListener(k.slice(2).toLowerCase(), v);
        else if (v !== undefined && v !== null) node.setAttribute(k, v);
      });
    }
    children.flat().forEach((c) => {
      if (c === null || c === undefined || c === false) return;
      node.appendChild(typeof c === "string" ? document.createTextNode(c) : c);
    });
    return node;
  }
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }

  // A flavor name that scrolls into view (instead of getting clipped with
  // "..." or overflowing the card on narrow screens) if it doesn't fit its
  // box — see the .lb-name-scroll CSS and applyNameMarquees below, which
  // actually measures and turns the animation on only where it's needed.
  function nameScrollEl(text, className) {
    return el("div", { class: "lb-name-scroll " + (className || "") },
      el("span", { class: "lb-name-inner" }, text)
    );
  }

  // Measures every .lb-name-scroll currently in the DOM and turns the
  // slide animation on only for the ones whose text is actually wider than
  // their box — run after each render pass since innerHTML gets rebuilt
  // from scratch every time. Cheap: a handful of elements, plain layout
  // reads, no writes inside the loop that would force extra reflows.
  function applyNameMarquees() {
    $all(".lb-name-scroll").forEach((wrap) => {
      const inner = wrap.querySelector(".lb-name-inner");
      if (!inner) return;
      const overflow = inner.scrollWidth - wrap.clientWidth;
      if (overflow > 1) {
        inner.style.setProperty("--lb-marquee-shift", "-" + overflow + "px");
        wrap.classList.add("is-overflowing");
      } else {
        wrap.classList.remove("is-overflowing");
      }
    });
  }

  /* ── LiveNumber-style animated counters ──────────────────────────────── */
  const liveNumberState = new Map();
  function animateNumber(node, key, toValue, duration) {
    duration = duration || 600;
    const prev = liveNumberState.get(key);
    const from = prev !== undefined ? prev : toValue;
    liveNumberState.set(key, toValue);
    if (from === toValue) { node.textContent = groupNumber(toValue); return; }
    const start = performance.now();
    function step(ts) {
      const progress = Math.min((ts - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      node.textContent = groupNumber(Math.round(from + (toValue - from) * eased));
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  /* ── Countdown (mirrors Countdown.tsx blocks variant) ────────────────── */
  function initCountdown() {
    const targetMs = new Date(SEASON_END_ISO).getTime();
    const dEl = $("#lb-cd-days"), hEl = $("#lb-cd-hrs"), mEl = $("#lb-cd-mins"), sEl = $("#lb-cd-secs");
    if (!dEl) return;
    function pad(n) { return String(n).padStart(2, "0"); }
    function tick() {
      const diff = Math.max(0, targetMs - Date.now());
      const d = Math.floor(diff / 86400000);
      const h = Math.floor((diff % 86400000) / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      dEl.textContent = pad(d); hEl.textContent = pad(h); mEl.textContent = pad(m); sEl.textContent = pad(s);
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ── Tilt3D pointer effect ────────────────────────────────────────────── */
  function attachTilt(node, max) {
    max = max || 7;
    node.style.transformStyle = "preserve-3d";
    node.style.transition = "transform 0.2s ease-out";
    node.addEventListener("pointermove", (e) => {
      const rect = node.getBoundingClientRect();
      const px = (e.clientX - rect.left) / rect.width - 0.5;
      const py = (e.clientY - rect.top) / rect.height - 0.5;
      const rx = py * -max, ry = px * max;
      node.style.transform = `perspective(1100px) rotateX(${rx}deg) rotateY(${ry}deg) translateY(-6px)`;
    });
    node.addEventListener("pointerleave", () => {
      node.style.transform = "perspective(1100px) rotateX(0deg) rotateY(0deg) translateY(0px)";
    });
  }

  /* ── Toast ────────────────────────────────────────────────────────────── */
  let toastTimer = null;
  function flash(msg) {
    const toast = $("#lb-toast");
    if (!toast) return;
    $("#lb-toast-text").textContent = msg;
    toast.classList.remove("hidden");
    requestAnimationFrame(() => toast.classList.add("lb-toast-visible"));
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(() => hideToast(), 2600);
  }
  function hideToast() {
    const toast = $("#lb-toast");
    if (!toast) return;
    toast.classList.remove("lb-toast-visible");
    setTimeout(() => toast.classList.add("hidden"), 200);
  }

  /* ── Vote modal (mirrors VoteEmailModal.tsx) ─────────────────────────── */
  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  const VoteModal = {
    target: null,
    step: "rate",
    firstName: "",
    lastInitial: "",
    score: null,
    duplicate: false,
    emailSent: false,
    ratingRowId: null,

    open(flavor) {
      if (Arena.hasVoted(flavor.id)) { flash(`You already rated ${flavor.name} ✓`); return; }
      this.target = flavor;
      this.step = "rate";
      this.firstName = ""; this.lastInitial = ""; this.score = null;
      this.duplicate = false; this.emailSent = false; this.ratingRowId = null;
      renderVoteModal();
      $("#lb-modal-backdrop").classList.remove("hidden");
    },
    close() {
      $("#lb-modal-backdrop").classList.add("hidden");
      this.target = null;
    },
    submit() {
      const errEl = $("#lb-modal-error");
      if (!this.firstName.trim()) { errEl.textContent = "Please enter your first name."; return; }
      if (!this.lastInitial.trim()) { errEl.textContent = "Please enter your last initial."; return; }
      if (this.score == null) { errEl.textContent = "Pick a score from 1 to 10 first."; return; }
      errEl.textContent = "";

      const submitBtn = $("#lb-modal-submit");
      submitBtn.disabled = true;
      submitBtn.textContent = "Counting your rating...";

      let ratingEmail = Arena.email;
      if (!ratingEmail || !ratingEmail.includes("@")) {
        try {
          let anon = localStorage.getItem(LS_ANON) || "";
          if (!anon) { anon = "anon_" + Math.random().toString(36).slice(2) + "@flavor52.local"; localStorage.setItem(LS_ANON, anon); }
          ratingEmail = anon;
        } catch { ratingEmail = "anon_" + Math.random().toString(36).slice(2) + "@flavor52.local"; }
      }

      setTimeout(() => {
        const result = Arena.castRating(this.target.id, this.score, ratingEmail);
        if (result === "duplicate") this.duplicate = true;

        if (result === "ok") {
          const realEmail = EMAIL_RE.test(Arena.email) ? Arena.email : null;
          const rowId = crypto.randomUUID();
          const flavorId = this.target.id;
          this.ratingRowId = rowId;
          supabaseInsertRating({
            id: rowId, flavor_id: flavorId, flavor_name: this.target.name,
            first_name: this.firstName.trim(), last_initial: this.lastInitial.trim(),
            rating: this.score, email: realEmail,
          }).then((r) => {
            // Once the insert has actually landed, the shared real total
            // already includes it — re-fetch and drop this visitor's local
            // optimistic copy so it isn't double-counted on top.
            if (r && r.ok) {
              Arena.refreshRealTotals().then(() => { Arena.clearPendingVote(flavorId); Arena.emit(); });
            }
          });
          // Show it in Live Activity immediately rather than waiting for the
          // next poll of real Supabase data to pick it up.
          LiveFeed.addOwnRating(this.target.id, this.firstName.trim(), this.lastInitial.trim(), this.score);
        }

        this.step = "success";
        renderVoteModal();
      }, 650);
    },
    submitEmail() {
      const input = $("#lb-modal-email-input");
      const clean = input.value.trim();
      const errEl = $("#lb-modal-email-error");
      if (!EMAIL_RE.test(clean) || !Arena.unlock(clean)) { errEl.textContent = "Please enter a valid email."; return; }
      errEl.textContent = "";
      this.emailSent = true;
      if (this.ratingRowId) supabaseAttachEmail(this.ratingRowId, clean);
      renderVoteModal();
    },
  };

  function renderVoteModal() {
    const root = $("#lb-modal-content");
    if (!root || !VoteModal.target) return;
    const t = VoteModal.target;

    if (VoteModal.step === "rate") {
      root.innerHTML = "";
      const scoresGrid = el("div", { class: "grid grid-cols-5 sm:grid-cols-10 gap-1.5" },
        ...Array.from({ length: 10 }, (_, i) => i + 1).map((n) => {
          const selected = VoteModal.score === n;
          const btn = el("button", {
            type: "button",
            class: "aspect-square rounded-lg font-heading font-black text-sm tabular-nums transition-all " + (selected ? "text-dark scale-105" : "bg-white/10 text-white/70 hover:bg-white/20"),
            "aria-pressed": selected,
            "aria-label": `Rate ${n} out of 10`,
            onClick: () => { VoteModal.score = n; renderVoteModal(); },
          }, String(n));
          if (selected) {
            btn.style.background = "linear-gradient(135deg, #FFCB05, #F2A516)";
            btn.style.boxShadow = "0 4px 14px -4px rgba(255,203,5,0.7)";
          }
          return btn;
        })
      );

      root.appendChild(el("div", { class: "relative z-10 px-7 pt-7 pb-8" },
        el("div", { class: "flex items-center gap-4 mb-5" },
          el("div", { class: "relative w-16 h-16 shrink-0" },
            el("div", { class: "absolute inset-0 rounded-full bg-gold/15 blur-xl scale-150" }),
            el("img", { src: t.image, alt: t.name, class: "relative w-full h-full object-contain drop-shadow-[0_6px_18px_rgba(255,203,5,0.2)]" })
          ),
          el("div", { class: "min-w-0" },
            el("p", { class: "text-gold text-[9px] font-black tracking-[0.4em] uppercase mb-0.5" }, "Rate it to keep it forever"),
            el("h3", { class: "text-white font-black text-lg leading-tight" }, t.name),
            el("p", { class: "text-white/45 text-xs font-semibold" }, t.combo),
            el("p", { class: "text-white/35 text-[10px] mt-0.5" }, `${Arena.averageRating(t.id).toFixed(1)} avg · ${groupNumber(Arena.displayCount(t.id))} votes`)
          )
        ),
        el("div", { class: "h-px bg-gradient-to-r from-transparent via-white/20 to-transparent mb-5" }),
        el("div", { class: "flex gap-3 mb-5" },
          el("div", { class: "flex-1" },
            el("label", { class: "block text-white/50 text-[9px] font-black tracking-[0.3em] uppercase mb-1.5" }, "First Name"),
            el("input", {
              type: "text", id: "lb-modal-firstname", placeholder: "Alex", autofocus: "true",
              class: "w-full px-3.5 py-2.5 rounded-xl text-sm bg-white/10 border border-white/20 text-white placeholder:text-white/30 focus:outline-none focus:border-gold/60 focus:bg-white/15 transition-all",
              value: VoteModal.firstName,
              onInput: (e) => { VoteModal.firstName = e.target.value; $("#lb-modal-error").textContent = ""; },
              onKeydown: (e) => { if (e.key === "Enter") VoteModal.submit(); },
            })
          ),
          el("div", { class: "w-24" },
            el("label", { class: "block text-white/50 text-[9px] font-black tracking-[0.3em] uppercase mb-1.5" }, "Last Initial"),
            el("input", {
              type: "text", id: "lb-modal-lastinitial", placeholder: "K", maxlength: "1",
              class: "w-full px-3.5 py-2.5 rounded-xl text-sm bg-white/10 border border-white/20 text-white placeholder:text-white/30 focus:outline-none focus:border-gold/60 focus:bg-white/15 transition-all text-center font-black text-base tracking-widest",
              value: VoteModal.lastInitial,
              onInput: (e) => { VoteModal.lastInitial = e.target.value.slice(0, 1).toUpperCase(); e.target.value = VoteModal.lastInitial; $("#lb-modal-error").textContent = ""; },
              onKeydown: (e) => { if (e.key === "Enter") VoteModal.submit(); },
            })
          )
        ),
        el("div", { class: "mb-5" },
          el("label", { class: "block text-white/50 text-[9px] font-black tracking-[0.3em] uppercase mb-2 text-center" }, "Your Rating — 1 to 10"),
          scoresGrid,
          VoteModal.score != null ? el("p", { class: "text-center text-gold font-black text-xs mt-2" },
            `${VoteModal.score}/10 — ${VoteModal.score >= 9 ? "Exceptional!" : VoteModal.score >= 7 ? "Great!" : VoteModal.score >= 5 ? "Good" : "Needs work"}`
          ) : null
        ),
        el("p", { id: "lb-modal-error", class: "text-red-300 text-xs mb-3 font-medium text-center" }),
        el("button", {
          id: "lb-modal-submit", type: "button",
          class: "relative w-full overflow-hidden py-3.5 rounded-xl font-extrabold text-sm tracking-wider flex items-center justify-center gap-2 text-dark disabled:opacity-50 disabled:cursor-not-allowed",
          style: "background: linear-gradient(90deg, #FFCB05 0%, #F2A516 50%, #FFCB05 100%); box-shadow: 0 10px 32px -6px rgba(255,203,5,0.6);",
          onClick: () => VoteModal.submit(),
        }, "⚡ Submit Rating"),
        el("p", { class: "text-center text-white/35 text-[10px] mt-3 tracking-wide font-medium" }, "One rating per flavor · Results update live")
      ));

      const fn = $("#lb-modal-firstname"); if (fn) fn.focus();
    } else {
      root.innerHTML = "";
      const successBody = [];
      if (VoteModal.duplicate) {
        successBody.push(
          el("h3", { class: "text-white font-black text-xl tracking-tight mb-2" }, "Already rated!"),
          el("p", { class: "text-white/55 text-sm mb-5" }, `Your verdict on `, el("span", { class: "text-gold font-bold" }, t.name), ` is already counted — one rating per flavor.`)
        );
      } else {
        successBody.push(
          el("h3", { class: "text-white font-black text-2xl tracking-tight mb-1" }, "Rating Counted! 🎉"),
          el("p", { class: "text-white/55 text-sm mb-1" }, `${VoteModal.firstName} ${VoteModal.lastInitial}. rated `, el("span", { class: "gradient-text font-black" }, t.name)),
          el("p", { class: "text-gold font-black text-3xl mb-4 tabular-nums" }, `${VoteModal.score}/10`)
        );
      }

      const optionsFeatured = getFlavorById(FEATURED_FLAVOR_ID) || FLAVORS[0];
      const optionButtonClass = "block w-full py-2.5 rounded-xl border border-white/15 bg-white/8 text-white font-bold text-sm text-center hover:opacity-80 transition-all";
      // Prefer the flavor the visitor just rated (t) — falls back to the
      // general blog index if that specific flavor has no post yet.
      const flavorLogUrl = t.flavorLogUrl || "https://javafactory.com/blogs/flavor-log";
      const postVoteOptions = el("div", { class: "space-y-2 mb-4" },
        el("a", { href: optionsFeatured.productUrl, target: "_blank", rel: "noopener noreferrer", class: optionButtonClass }, "🛒 Get This Week's Flavor"),
        el("a", { href: flavorLogUrl, target: "_blank", rel: "noopener noreferrer", class: optionButtonClass }, "📖 Read The Flavor Log")
        // RAG chatbot button removed per client request — revisit once it's actually built.
      );

      let signupBlock;
      if (!VoteModal.emailSent && !Arena.unlocked) {
        signupBlock = el("div", { class: "rounded-2xl border border-white/15 bg-white/8 p-4 text-left" },
          el("p", { class: "text-white font-black text-sm mb-0.5" }, "Wanna be informed about Next Week's Flavor?"),
          el("p", { class: "text-white/45 text-xs mb-3 leading-relaxed" }, "Get the drop straight to your inbox — free, every week."),
          el("input", {
            type: "email", id: "lb-modal-email-input", placeholder: "your@email.com",
            class: "w-full px-3.5 py-2.5 rounded-xl text-sm bg-white/10 border border-white/20 text-white placeholder:text-white/30 focus:outline-none focus:border-gold/60 focus:bg-white/15 transition-all mb-2.5",
            onKeydown: (e) => { if (e.key === "Enter") VoteModal.submitEmail(); },
          }),
          el("p", { id: "lb-modal-email-error", class: "text-red-300 text-xs mb-2 font-medium" }),
          el("button", {
            type: "button", class: "w-full py-2.5 rounded-xl font-black text-sm tracking-wide text-dark mb-2",
            style: "background: linear-gradient(90deg, #FFCB05, #F2A516); box-shadow: 0 6px 20px -4px rgba(255,203,5,0.45);",
            onClick: () => VoteModal.submitEmail(),
          }, "Yes, notify me!"),
          el("button", { type: "button", class: "w-full py-1.5 text-white/35 text-xs font-semibold hover:text-white/60 transition-colors", onClick: () => VoteModal.close() }, "No thanks")
        );
      } else if (VoteModal.emailSent) {
        signupBlock = el("div", { class: "rounded-2xl border border-gold/30 bg-gold/8 p-4" },
          el("p", { class: "text-gold font-black text-base mb-1" }, "You're in! 🎉"),
          el("p", { class: "text-white/50 text-xs mb-3" }, "We'll ping you when the next flavor drops."),
          el("button", { type: "button", class: "w-full py-2.5 rounded-xl border border-gold/50 text-gold font-bold text-sm hover:bg-gold/15 transition-all", onClick: () => VoteModal.close() }, "Keep Rating")
        );
      } else {
        signupBlock = el("button", { type: "button", class: "w-full py-2.5 rounded-xl border border-gold/50 text-gold font-bold text-sm hover:bg-gold/15 transition-all", onClick: () => VoteModal.close() }, "Keep Rating");
      }

      root.appendChild(el("div", { class: "relative z-10 px-7 pt-7 pb-8 text-center" },
        el("div", { class: "relative inline-block mb-3" },
          el("div", { class: "absolute inset-0 rounded-full bg-gold/30 blur-2xl scale-[2]" }),
          el("span", { class: "relative text-gold text-5xl", html: "&#10003;" })
        ),
        ...successBody,
        postVoteOptions,
        signupBlock
      ));
    }
  }

  /* ── Ranked list + locked list ────────────────────────────────────────── */
  // Ranks 1-5 are ALL safe (permanent spot at season end) — only rank 6+ is
  // actually eliminated. Rank 5 is the Company Save slot (always Monkey Bread)
  // so the label at #5 is the one that should carry real urgency.
  const MOVEMENT_LABELS = {
    1: { text: "🔥 Trending", color: "#e68600" },
    2: { text: "👀 Closing in", color: "#6b7280" },
    3: { text: "✅ Safe", color: "#16a34a" },
    4: { text: "✅ Safe", color: "#16a34a" },
    5: { text: "⚠️ On the bubble", color: "#dc2626" },
  };

  // Ranks 1-5 are safe (permanent spot on the menu at season end). Rank 6+
  // is currently eliminated. Rank 6 specifically gets alternating urgency
  // copy, but only once a 7th flavor is released to actually threaten it —
  // otherwise there's nothing "one spot away" about it.
  const ELIMINATED_ALTERNATE_TEXTS = ["CURRENTLY ELIMINATED", "SAVE ME", "ONE SPOT AWAY FROM SURVIVAL"];

  function cupImage(f) {
    const img = el("img", { src: f.image, alt: f.name, class: "w-full h-full object-contain drop-shadow" });
    return f.productUrl
      ? el("a", { href: f.productUrl, target: "_blank", rel: "noopener noreferrer", class: "block w-full h-full hover:opacity-80 transition-opacity" }, img)
      : img;
  }

  function renderRankedList() {
    const root = $("#lb-ranked-list");
    if (!root) return;
    root.innerHTML = "";

    const releasedFlavors = FLAVORS.filter(isReleased);
    const lockedFlavors = FLAVORS.filter((f) => inCurrentSeason(f) && !isReleased(f));
    const ranked = sortBySpotlightThenRating(releasedFlavors);
    const leaderId = Arena.leaderId();

    ranked.forEach((f, i) => {
      const rank = i + 1;
      const safe = rank <= 5;
      const count = Arena.displayCount(f.id);
      const avg = Arena.averageRating(f.id);
      const voted = Arena.hasVoted(f.id);
      const isLeader = f.id === leaderId;

      let statusText, statusColor;
      if (safe) {
        const movement = MOVEMENT_LABELS[rank] || { text: "Currently safe", color: "#6b7280" };
        statusText = movement.text; statusColor = movement.color;
      } else {
        statusColor = "#dc2626";
        if (rank === 5 && ranked.length >= 6) {
          const idx = Math.floor(Date.now() / 3000) % ELIMINATED_ALTERNATE_TEXTS.length;
          statusText = ELIMINATED_ALTERNATE_TEXTS[idx];
        } else {
          statusText = "CURRENTLY ELIMINATED";
        }
      }

      if (rank === 5) {
        root.appendChild(el("div", { class: "relative mt-1 mb-1 flex items-center gap-3 px-1" },
          el("div", { class: "flex-1 h-px", style: "background: linear-gradient(to right, transparent, rgba(220,38,38,0.5));" }),
          el("span", { class: "text-[10px] font-black tracking-[0.2em] uppercase shrink-0", style: "color: #dc2626;" }, "Elimination Line"),
          el("div", { class: "flex-1 h-px", style: "background: linear-gradient(to left, transparent, rgba(220,38,38,0.5));" })
        ));
      }

      const row = el("div", {
        class: "flex items-center gap-2.5 sm:gap-4 px-2.5 sm:px-3 py-3 rounded-lg hover:bg-purple/[0.05] transition-colors border-b border-dark/5 last:border-0",
        style: safe ? "" : "background: rgba(220,38,38,0.03);",
      },
        el("span", { class: `w-6 text-center font-heading font-black tabular-nums ${rank === 1 ? "gradient-text-purple text-xl" : "text-dark"}` }, String(rank)),
        el("div", { class: "relative w-10 h-10 sm:w-11 sm:h-11 shrink-0" }, cupImage(f)),
        el("div", { class: "flex-1 min-w-0" },
          el("div", { class: "flex items-center gap-2" },
            nameScrollEl(f.name, "flex-1 min-w-0 font-heading font-bold text-sm sm:text-base"),
            isLeader ? el("span", { class: "hidden sm:inline-flex items-center gap-1 shimmer-badge text-dark font-extrabold text-[8px] tracking-wider px-2 py-0.5 rounded-full" }, "🔥 TOP RATED") : null
          ),
          el("div", { class: "mt-1.5 h-1.5 bg-dark/8 rounded-full overflow-hidden" },
            el("div", {
              class: `h-full rounded-full transition-[width] duration-700 ease-out ${safe ? (isLeader ? "bg-gradient-to-r from-gold to-amber" : "bg-gradient-to-r from-purple to-dark-purple") : ""}`,
              style: `width: ${(avg / 10) * 100}%;` + (safe ? "" : " background: linear-gradient(to right, #dc2626, #f87171);"),
            })
          ),
          el("p", { class: "text-[10px] font-bold mt-1", style: `color: ${statusColor}` }, statusText)
        ),
        el("div", { class: "text-right w-14 sm:w-16 shrink-0" },
          el("span", { class: "block font-heading font-black text-base sm:text-lg tabular-nums text-amber" }, avg.toFixed(1)),
          el("span", { class: "text-dark text-[9px] font-bold tracking-wider tabular-nums" }, `${groupNumber(count)} votes`)
        ),
        voted
          ? el("div", { class: "w-16 sm:w-20 shrink-0 flex items-center justify-center gap-1 py-2 rounded-lg bg-emerald-500/12 border border-emerald-500/30 text-emerald-400 font-black text-[11px]" }, "✓ RATED")
          : el("button", { class: "jf-btn-hover relative overflow-hidden w-16 sm:w-20 shrink-0 py-2 rounded-lg bg-gradient-to-r from-amber to-[#e68600] shadow-md shadow-amber/25 text-dark font-heading font-black text-[11px] tracking-wider", onClick: () => VoteModal.open(f) }, el("span", { class: "relative z-10" }, "RATE"))
      );
      root.appendChild(row);
    });

    lockedFlavors.forEach((f) => {
      // Flavors flagged mysteryUntilUnlocked (currently just Monkey Bread)
      // stay a "?" placeholder even while locked — no name/image reveal —
      // unlike normal locked flavors, which do show their real name/image
      // grayed out. Client wants zero early reveal on this one specifically.
      const mystery = f.mysteryUntilUnlocked;
      root.appendChild(el("div", { class: "flex items-center gap-2.5 sm:gap-4 px-2.5 sm:px-3 py-3 rounded-lg border-b border-dark/5 last:border-0 opacity-50" },
        el("span", { class: "w-6 text-center text-dark/25 text-center" }, mystery ? "❓" : "🔒"),
        mystery
          ? el("div", { class: "relative w-10 h-10 sm:w-11 sm:h-11 shrink-0 flex items-center justify-center text-xl text-dark/25" }, "❓")
          : el("div", { class: "relative w-10 h-10 sm:w-11 sm:h-11 shrink-0 grayscale" }, cupImage(f)),
        el("div", { class: "flex-1 min-w-0" },
          nameScrollEl(mystery ? `SEASON ${f.season} MYSTERY FLAVOR` : f.name, "font-heading font-bold text-sm sm:text-base text-dark"),
          el("p", { class: "text-dark text-[11px] font-semibold" }, mystery ? "Reveal TBD" : `Drops week ${f.weekNumber}`)
        ),
        el("div", { class: "w-16 sm:w-20 shrink-0 flex items-center justify-center gap-1 py-2 rounded-lg bg-dark/5 border border-dark/10 text-dark/40 font-black text-[10px] tracking-wider" }, "🔒 LOCKED")
      ));
    });
    applyNameMarquees();
  }

  /* ── Hall of Flavor ───────────────────────────────────────────────────── */
  // The Hall of Flavor is meant to be Season 1's final, permanent result —
  // not a live leaderboard, since normal voting movement would otherwise
  // make flavors go in and out of it all season. It stays an empty
  // "revealed at season end" placeholder until the client flips
  // flavor52_season1_hall_revealed on in Theme Settings.
  const HALL_REVEALED = !!CONFIG.season1HallRevealed;

  // Client-specified final Season 1 order (Oatmeal Cookie, Candied Pecan,
  // Sunday Pancakes, Grandma's Candy, + Monkey Bread via Company Save),
  // locked in ahead of the Season 2 launch. Hardcoded rather than derived
  // from live ratings so it can't shift if more real votes land on these
  // flavors before the reveal actually deploys — the seed ratings above are
  // also tuned to match this order as a backstop, but this list is the
  // source of truth. The 5th entry (id 8, Monkey Bread) is the Company Save.
  const SEASON_1_HALL_ORDER = [7, 2, 1, 4, 8];
  const COMPANY_SAVE_ID = 8;
  const SEASON_2_HALL_ORDER = [9, 10, 12, 15, 16];
  const SEASON_2_COMPANY_SAVE_ID = 16;

  function renderHallOfFlavor() {
    const activeRoot = $("#lb-hall-active");
    const subtitleEl = $("#lb-hall-subtitle");
    const leadersLabelEl = $("#lb-hall-leaders-label");
    if (!activeRoot) return;

    if (subtitleEl) {
      subtitleEl.textContent = HALL_REVEALED
        ? "Top 4 + 1 Company Save earn a permanent spot. Season 1 is complete — these are the final results."
        : "Top 4 + 1 Company Save earn a permanent spot on the menu forever. Revealed once Season 1 wraps.";
    }
    if (leadersLabelEl) leadersLabelEl.textContent = HALL_REVEALED ? "Season 1 · Final Results" : "Revealed at the end of Season 1";

    activeRoot.innerHTML = "";
    if (!HALL_REVEALED) {
      for (let i = 0; i < 5; i++) {
        activeRoot.appendChild(el("div", { class: "relative rounded-3xl border-2 border-dashed border-dark/15 p-5 sm:p-7 flex flex-col items-center text-center gap-3 h-full opacity-40", style: "min-width:160px;width:160px;flex-shrink:0;" },
          el("div", { class: "relative w-24 h-24 sm:w-32 sm:h-32 shrink-0 mt-4 flex items-center justify-center text-4xl text-dark/30" }, "🏆"),
          el("span", { class: "font-heading font-black text-base text-dark" }, `Spot #${i + 1}`),
          el("p", { class: "text-dark text-xs" }, "Locked in at season's end")
        ));
      }
    } else {
      const ranked = SEASON_1_HALL_ORDER.map(getFlavorById).filter(Boolean);
      ranked.forEach((f, i) => {
        const isCompanySave = f.id === COMPANY_SAVE_ID;
        const cardTag = f.productUrl ? "a" : "div";
        const cardAttrs = { class: "relative rounded-3xl border border-gold/40 p-5 sm:p-7 flex flex-col items-center text-center gap-3 h-full hover:opacity-90 transition-opacity", style: "background: linear-gradient(135deg, rgba(255,203,5,0.18), rgba(146,39,143,0.12));" };
        if (f.productUrl) { cardAttrs.href = f.productUrl; cardAttrs.target = "_blank"; cardAttrs.rel = "noopener noreferrer"; }
        const card = el(cardTag, cardAttrs,
          el("span", { class: "absolute top-3 left-3 text-[9px] font-black text-dark bg-gold px-2.5 py-1 tracking-wider" }, isCompanySave ? "SAVE" : `#${i + 1}`),
          el("span", { class: "absolute top-3 right-3 text-[9px] font-black text-white bg-purple/80 px-2 py-0.5 rounded-full tracking-wider" }, isCompanySave ? "COMPANY SAVE" : "FINAL"),
          el("div", { class: "relative w-24 h-24 sm:w-32 sm:h-32 shrink-0 mt-4" }, el("img", { src: f.image, alt: f.name, class: "w-full h-full object-contain drop-shadow-[0_8px_24px_rgba(146,39,143,0.35)]" })),
          el("div", { class: "min-w-0 w-full" },
            nameScrollEl(f.name, "font-heading font-black text-base sm:text-lg leading-tight"),
            el("p", { class: "text-dark text-xs font-semibold mt-0.5" }, f.combo),
            el("p", { class: "font-heading text-amber font-black text-2xl sm:text-3xl mt-2 tabular-nums leading-none" }, Arena.averageRating(f.id).toFixed(1)),
            el("p", { class: "text-dark text-[10px] font-black tracking-[0.2em] mt-0.5" }, "AVG RATING")
          )
        );
        const tiltWrap = el("div", { style: "min-width:160px;width:160px;flex-shrink:0;" }, card);
        activeRoot.appendChild(tiltWrap);
        attachTilt(tiltWrap, 5);
      });
      for (let i = 0; i < 5 - ranked.length; i++) {
        const pos = ranked.length + i + 1;
        const label = pos === 2 ? "2nd Place" : pos === 3 ? "3rd Place" : pos === 4 ? "4th Place" : "5th Place";
        activeRoot.appendChild(el("div", { class: "relative rounded-3xl border-2 border-dashed border-dark/15 p-5 sm:p-7 flex flex-col items-center text-center gap-3 h-full opacity-40", style: "min-width:160px;width:160px;flex-shrink:0;" },
          el("div", { class: "relative w-24 h-24 sm:w-32 sm:h-32 shrink-0 mt-4 flex items-center justify-center text-4xl text-dark/30" }, "🔒"),
          el("span", { class: "font-heading font-black text-base text-dark" }, label),
          el("p", { class: "text-dark text-xs" }, "Drops as more flavors release")
        ));
      }
    }

    // Season 2 Hall of Flavor
    const s2Root = $("#lb-hall-s2-active");
    if (s2Root) {
      s2Root.innerHTML = "";
      const s2Ranked = SEASON_2_HALL_ORDER.map(getFlavorById).filter(Boolean);
      s2Ranked.forEach((f, i) => {
        const isCompanySave = f.id === SEASON_2_COMPANY_SAVE_ID;
        const cardTag = f.productUrl ? "a" : "div";
        const cardAttrs = { class: "relative rounded-3xl border border-gold/40 p-5 sm:p-7 flex flex-col items-center text-center gap-3 h-full hover:opacity-90 transition-opacity", style: "background: linear-gradient(135deg, rgba(255,203,5,0.18), rgba(146,39,143,0.12));" };
        if (f.productUrl) { cardAttrs.href = f.productUrl; cardAttrs.target = "_blank"; cardAttrs.rel = "noopener noreferrer"; }
        const card = el(cardTag, cardAttrs,
          el("span", { class: "absolute top-3 left-3 text-[9px] font-black text-dark bg-gold px-2.5 py-1 tracking-wider" }, isCompanySave ? "SAVE" : `#${i + 1}`),
          el("span", { class: "absolute top-3 right-3 text-[9px] font-black text-white bg-purple/80 px-2 py-0.5 rounded-full tracking-wider" }, isCompanySave ? "COMPANY SAVE" : "FINAL"),
          el("div", { class: "relative w-24 h-24 sm:w-32 sm:h-32 shrink-0 mt-4" }, el("img", { src: f.image, alt: f.name, class: "w-full h-full object-contain drop-shadow-[0_8px_24px_rgba(146,39,143,0.35)]" })),
          el("div", { class: "min-w-0 w-full" },
            nameScrollEl(f.name, "font-heading font-black text-base sm:text-lg leading-tight"),
            el("p", { class: "text-dark text-xs font-semibold mt-0.5" }, f.combo),
            el("p", { class: "font-heading text-amber font-black text-2xl sm:text-3xl mt-2 tabular-nums leading-none" }, Arena.averageRating(f.id).toFixed(1)),
            el("p", { class: "text-dark text-[10px] font-black tracking-[0.2em] mt-0.5" }, "AVG RATING")
          )
        );
        const tiltWrap = el("div", { style: "min-width:160px;width:160px;flex-shrink:0;" }, card);
        s2Root.appendChild(tiltWrap);
        attachTilt(tiltWrap, 5);
      });
    }

    applyNameMarquees();

    // Drag-to-scroll on the Hall of Flavor scroll wrapper
    const hallScroll = activeRoot && activeRoot.parentElement;
    if (hallScroll && hallScroll.classList.contains("lb-hall-scroll")) {
      let isDown = false, startX = 0, scrollLeft = 0;
      hallScroll.style.cursor = "grab";
      hallScroll.addEventListener("mousedown", (e) => {
        isDown = true;
        hallScroll.style.cursor = "grabbing";
        startX = e.pageX - hallScroll.offsetLeft;
        scrollLeft = hallScroll.scrollLeft;
        e.preventDefault();
      });
      hallScroll.addEventListener("mouseleave", () => { isDown = false; hallScroll.style.cursor = "grab"; });
      hallScroll.addEventListener("mouseup", () => { isDown = false; hallScroll.style.cursor = "grab"; });
      hallScroll.addEventListener("mousemove", (e) => {
        if (!isDown) return;
        const x = e.pageX - hallScroll.offsetLeft;
        hallScroll.scrollLeft = scrollLeft - (x - startX) * 1.5;
      });
      // Touch is native — no extra handling needed
    }

    // Drag-to-scroll on the Season 2 Hall scroll wrapper
    const s2Scroll = s2Root && s2Root.parentElement;
    if (s2Scroll && s2Scroll.classList.contains("lb-hall-scroll")) {
      let isDown = false, startX = 0, scrollLeft = 0;
      s2Scroll.style.cursor = "grab";
      s2Scroll.addEventListener("mousedown", (e) => {
        isDown = true;
        s2Scroll.style.cursor = "grabbing";
        startX = e.pageX - s2Scroll.offsetLeft;
        scrollLeft = s2Scroll.scrollLeft;
        e.preventDefault();
      });
      s2Scroll.addEventListener("mouseleave", () => { isDown = false; s2Scroll.style.cursor = "grab"; });
      s2Scroll.addEventListener("mouseup", () => { isDown = false; s2Scroll.style.cursor = "grab"; });
      s2Scroll.addEventListener("mousemove", (e) => {
        if (!isDown) return;
        const x = e.pageX - s2Scroll.offsetLeft;
        s2Scroll.scrollLeft = scrollLeft - (x - startX) * 1.5;
      });
    }
  }

  /* ── Live activity feed render ────────────────────────────────────────── */
  function renderLiveFeed() {
    const root = $("#lb-live-activity");
    if (!root) return;
    root.innerHTML = "";

    if (!LiveFeed.entries.length) {
      root.appendChild(el("p", { class: "text-dark/40 text-sm" }, LiveFeed.loaded ? "No ratings yet — be the first!" : "Loading recent activity…"));
      return;
    }

    LiveFeed.entries.forEach((a) => {
      const fl = getFlavorById(a.flavorId);
      const row = el("div", { class: "flex items-center gap-3 py-2.5 border-b border-dark/5 last:border-0" },
        el("div", { class: "relative w-9 h-9 shrink-0" }, fl ? el("img", { src: fl.image, alt: "", class: "w-full h-full object-contain drop-shadow" }) : null),
        el("div", { class: "flex-1 min-w-0" },
          el("p", { class: "text-dark text-[13px] leading-tight truncate" }, el("span", { class: "font-bold" }, a.who), " rated ", el("span", { class: "font-semibold" }, fl ? fl.name : ""))
        ),
        el("span", { class: "text-amber font-black text-xs tabular-nums shrink-0" }, `★ ${a.rating}/10`)
      );
      root.appendChild(row);
    });
  }
  // Keeps rank #5's "SAVE ME" / "ONE SPOT AWAY FROM SURVIVAL" / "CURRENTLY
  // ELIMINATED" text actually cycling, not just re-rolled on vote events.
  setInterval(() => renderRankedList(), 3000);

  /* ── Hero ─────────────────────────────────────────────────────────────── */
  function renderHero() {
    const featured = getFlavorById(FEATURED_FLAVOR_ID) || FLAVORS[0];

    const imgEl = $("#lb-hero-image");
    if (imgEl) { imgEl.src = featured.image; imgEl.alt = featured.name; }

    const flavorNumberEl = $("#lb-hero-flavor-number");
    if (flavorNumberEl) flavorNumberEl.textContent = `Flavor ${featured.weekNumber} of ${TOTAL_FLAVORS}`;

    const nameEl = $("#lb-hero-name");
    if (nameEl) {
      nameEl.textContent = featured.name;
      const len = featured.name.length;
      let size = "clamp(1.2rem, 3.5vw, 2.8rem)";
      if (len <= 8) size = "clamp(3rem, 9vw, 6rem)";
      else if (len <= 12) size = "clamp(2.5rem, 7vw, 5rem)";
      else if (len <= 16) size = "clamp(2rem, 5.5vw, 4rem)";
      else if (len <= 22) size = "clamp(1.5rem, 4.5vw, 3.5rem)";
      nameEl.style.fontSize = size;
    }
    const comboEl = $("#lb-hero-combo"); if (comboEl) comboEl.textContent = featured.combo;
    const weekBadge = $("#lb-hero-week-badge"); if (weekBadge) weekBadge.textContent = "THIS WEEK'S FLAVOR · WEEK " + featured.weekNumber;
    const heroLink = $("#lb-hero-link"); if (heroLink) heroLink.href = featured.productUrl;

    const avg = Arena.averageRating(featured.id);
    const ratingEl = $("#lb-hero-rating"); if (ratingEl) ratingEl.textContent = avg.toFixed(1);

    const starsRoot = $("#lb-hero-stars");
    if (starsRoot) {
      starsRoot.innerHTML = "";
      for (let i = 1; i <= 5; i++) {
        starsRoot.appendChild(el("span", { class: "text-lg " + (avg >= i * 2 ? "text-gold" : "text-white/15") }, "★"));
      }
    }

    const countEl = $("#lb-hero-ratings-cast");
    if (countEl) animateNumber(countEl, "hero-count", Arena.displayCount(featured.id));

    const ctaRoot = $("#lb-hero-cta");
    if (ctaRoot) {
      ctaRoot.innerHTML = "";
      if (Arena.hasVoted(featured.id)) {
        ctaRoot.appendChild(el("div", {
          class: "w-full lg:w-auto lg:min-w-[260px] py-4 px-10 font-black text-base tracking-[0.04em] uppercase flex items-center justify-center gap-3",
          style: "background: rgba(16,185,129,0.15); color: #34d399; border-radius: 40px; border: 1.5px solid rgba(52,211,153,0.4); box-shadow: 0 4px 16px rgba(16,185,129,0.15);",
        }, "✓ RATED"));
      } else {
        ctaRoot.appendChild(el("button", {
          class: "jf-btn-hover relative w-full lg:w-auto lg:min-w-[260px] overflow-hidden py-4 px-10 font-black text-base tracking-[0.04em] uppercase flex items-center justify-center gap-3",
          style: "background: #F19304; color: #FFFFFF; border-radius: 40px; border: none; box-shadow: 0 4px 6px rgba(0,0,0,0.25);",
          onClick: () => VoteModal.open(featured),
        }, el("span", { class: "relative z-10" }, "RATE " + featured.name)));
      }
    }

    return featured;
  }

  /* ── Post-it note (random prompt, stable per page load) ───────────────
     All 3 prompts are plain client-written copy, editable in Shopify Theme
     Settings — none are computed from real data (this used to compute
     "THIS WEEK'S FLAVOR" from the featured flavor's actual live rank, but
     the client wants full control over the wording instead). */
  function initPostIt() {
    const el_ = $("#lb-postit-label"), linesEl = $("#lb-postit-lines");
    if (!el_ || !linesEl) return;

    const weekFlavor = CONFIG.weekFlavor || {};
    const votingStatus = CONFIG.votingStatus || {};
    const communityResponse = CONFIG.communityResponse || {};
    const PROMPTS = [
      { label: "THIS WEEK'S FLAVOR", lines: [
        weekFlavor.line1 || "Climbing the ranks",
        weekFlavor.line2 || "Every vote counts",
        weekFlavor.line3 || "Vote now to push it up",
      ] },
      { label: "VOTING STATUS", lines: [
        votingStatus.line1 || "Today's favorite...",
        votingStatus.line2 || "could be tomorrow's upset.",
        votingStatus.line3 || "Keep voting.",
      ] },
      { label: "COMMUNITY RESPONSE", lines: [
        communityResponse.line1 || "84% said",
        communityResponse.line2 || "\"I'd buy this again.\"",
        communityResponse.line3 || "Rate it and see where you stand",
      ] },
    ];
    const idx = Math.floor(Math.random() * PROMPTS.length);
    const p = PROMPTS[idx];
    el_.textContent = p.label;
    linesEl.innerHTML = "";
    p.lines.forEach((line) => linesEl.appendChild(el("p", { style: "margin:0" }, line)));
  }

  /* ── Stats + status bar ───────────────────────────────────────────────── */
  function renderStats() {
    const weekStatusEl = $("#lb-week-status");
    const SEASON_NAMES = { 1: "THROWBACK COLLECTION", 2: "ICE CREAM TRUCK" };
    if (weekStatusEl) weekStatusEl.textContent = `SEASON ${CURRENT_SEASON} · ${SEASON_NAMES[CURRENT_SEASON] || "COLLECTION"}`;
    const flavorCountEl = $("#lb-flavor-count-label");
    if (flavorCountEl) flavorCountEl.textContent = `${FLAVORS.filter(inCurrentSeason).length} flavors`;
  }

  /* ── Biggest movers ────────────────────────────────────────────────────
     Explicit, client-approved exception to "no fabricated data" (see the
     synthetic-vote comment above syntheticStatsFor) — the previous version
     computed real rank-crossover from a week-over-week Supabase vote-count
     comparison, but that was genuinely empty most of the time (not enough
     real movement yet to show anything), which the client didn't want.
     Since only the top 4 ever matter long-term (same top 4 that earn a
     permanent Hall of Flavor spot), this instead always shows the current
     top 4 by real rating, with a guaranteed, deterministic "+N" by
     position — first place always leads, in descending order — so the
     widget is never empty once anything is released. */
  function renderBiggestMovers() {
    const root = $("#lb-biggest-movers");
    if (!root) return;

    const top = sortBySpotlightThenRating(FLAVORS.filter(isReleased)).slice(0, 4);

    root.innerHTML = "";
    if (!top.length) {
      root.appendChild(el("p", { class: "text-dark/40 text-sm" }, "Nothing to report yet — check back soon."));
      return;
    }
    const n = top.length;
    top.forEach((f, i) => {
      const delta = n - i;
      root.appendChild(el("div", { class: "flex items-center justify-between gap-3" },
        nameScrollEl(f.name, "flex-1 min-w-0 text-dark font-semibold text-sm"),
        el("span", {
          class: "shrink-0 font-black text-sm tabular-nums px-2 py-0.5 rounded-full",
          style: "background: rgba(22,163,74,0.1); color: #16a34a;",
        }, "+" + delta)
      ));
    });
    applyNameMarquees();
  }

  /* ── "How it works" auto-advancing steps ─────────────────────────────── */
  function initHowSteps() {
    const buttons = $all(".lb-how-step");
    if (!buttons.length) return;
    let active = 0, paused = false;

    function apply() {
      buttons.forEach((btn, i) => {
        const on = i === active;
        const accent = btn.dataset.accent;
        const badge = btn.querySelector(".lb-how-badge");
        const kicker = btn.querySelector(".lb-how-kicker");
        badge.style.background = on ? accent : "#FFFFFF";
        badge.style.color = on ? btn.dataset.badgeText : accent;
        badge.style.boxShadow = on ? `0 14px 30px -10px ${accent}88` : "0 6px 16px -8px rgba(60,30,90,0.25)";
        badge.style.transform = on ? "scale(1.05)" : "scale(1)";
        kicker.style.opacity = on ? "1" : "0.5";
      });
    }
    buttons.forEach((btn, i) => {
      btn.addEventListener("click", () => { active = i; apply(); });
      btn.addEventListener("mouseenter", () => { active = i; apply(); paused = true; });
      btn.addEventListener("mouseleave", () => { paused = false; });
    });
    apply();
    setInterval(() => { if (!paused) { active = (active + 1) % buttons.length; apply(); } }, 2800);
  }

  /* ── Wire up static buttons (rally, scroll-to, toast dismiss, modal close) */
  function initStaticHandlers() {
    const rallyBtn = $("#lb-rally-btn");
    if (rallyBtn) rallyBtn.addEventListener("click", () => flash("🔗 Invite link copied — go rally the votes!"));

    $all("[data-scroll-to]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const target = document.getElementById(btn.dataset.scrollTo);
        if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });

    const toastClose = $("#lb-toast-close");
    if (toastClose) toastClose.addEventListener("click", hideToast);

    const modalBackdrop = $("#lb-modal-backdrop");
    if (modalBackdrop) {
      modalBackdrop.addEventListener("click", (e) => { if (e.target === modalBackdrop) VoteModal.close(); });
    }
    const modalClose = $("#lb-modal-close");
    if (modalClose) modalClose.addEventListener("click", () => VoteModal.close());
  }

  /* ── Main render (called on init + every Arena state change) ─────────── */
  let heroFeatured = null;
  function render() {
    heroFeatured = renderHero();
    renderStats();
    renderRankedList();
    renderHallOfFlavor();
    renderLiveFeed();
    renderBiggestMovers();
  }

  /* ── Boot ─────────────────────────────────────────────────────────────── */
  document.addEventListener("DOMContentLoaded", () => {
    Arena.hydrate();
    LiveFeed.init();
    Arena.onChange(render);

    // Real vote counts/ratings — the same shared data for every visitor —
    // load on boot and refresh every 30s so other people's votes show up
    // without a reload, same cadence as the Live Activity feed.
    Arena.refreshRealTotals();
    setInterval(() => Arena.refreshRealTotals(), 30000);

    // Real, shared unlock timestamps — same cadence, so a flavor unlocked
    // while visitors already have the page open still starts growing
    // automatically within 30s, not just on the next fresh page load.
    refreshFlavorUnlocks();
    setInterval(() => refreshFlavorUnlocks(), 30000);

    render();
    initPostIt();
    initCountdown();
    initHowSteps();
    initStaticHandlers();
    renderBiggestMovers();

    const heroTiltRoot = $("#lb-hero-tilt");
    if (heroTiltRoot) attachTilt(heroTiltRoot, 12);

    // Background live tick — mirrors ArenaProvider's 450s interval
    const prefersReduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!prefersReduced) setInterval(() => Arena.tick(), 450000);

    // Synthetic votes for every unlocked Season 2 flavor are now purely a
    // function of real elapsed time (see syntheticStatsFor above) — there's
    // nothing to initialize or catch up on boot any more. renderRankedList
    // already re-renders itself every 3s and picks the growing count up
    // automatically; this lighter heartbeat keeps the hero section and
    // other Arena-driven numbers in sync too, without needing an actual
    // vote/rating event to trigger a re-render.
    if (!prefersReduced) setInterval(() => Arena.emit(), 60000);
  });
})();
